import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import CalendarIcon from "assets/images/calendar-icon.svg"; // Adjust path as needed

const MonthPicker = ({ selectedDate, onChange, isClearable, placeholder = "Select Month" }) => {
  return (
    <div className="custom-month-picker">
      <DatePicker
        selected={selectedDate}
        onChange={onChange}
        dateFormat="MM/yyyy"
        showMonthYearPicker
        placeholderText={placeholder}
        className="form-control"
        // Optional: adds a calendar icon or specific styling
        isClearable={isClearable}
      />
    </div>
  );
};

export default MonthPicker;